// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js,json_types=true"
// @generated from file protobuf/journey/data/categories/marketplace_property_category.proto (package od_protos.journey.data.categories, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Int32ValueJson, Int64ValueJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import { file_protobuf_journey_data_options_options } from "../options/options_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file protobuf/journey/data/categories/marketplace_property_category.proto.
 */
export const file_protobuf_journey_data_categories_marketplace_property_category: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_protobuf_journey_data_options_options]);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory
 */
export type MarketplacePropertyCategory = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory"> & {
  /**
   * Next ID: 32
   *
   * @generated from oneof od_protos.journey.data.categories.MarketplacePropertyCategory.event
   */
  event: {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent detail_page_view = 1;
     */
    value: MarketplacePropertyCategory_DetailPageViewEvent;
    case: "detailPageView";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent similar_homes_click = 2;
     */
    value: MarketplacePropertyCategory_SimilarHomesClickEvent;
    case: "similarHomesClick";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent tour_booking_start = 3;
     */
    value: MarketplacePropertyCategory_TourBookingStartEvent;
    case: "tourBookingStart";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent reaction = 4;
     */
    value: MarketplacePropertyCategory_ReactionEvent;
    case: "reaction";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent offer_start = 5;
     */
    value: MarketplacePropertyCategory_OfferStartEvent;
    case: "offerStart";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent share = 6;
     */
    value: MarketplacePropertyCategory_ShareEvent;
    case: "share";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent rental_scam_banner_view = 7;
     */
    value: MarketplacePropertyCategory_RentalScamBannerViewEvent;
    case: "rentalScamBannerView";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent rental_scam_banner_learn_more = 8;
     */
    value: MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent;
    case: "rentalScamBannerLearnMore";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent natural_language_search = 9;
     */
    value: MarketplacePropertyCategory_NaturalLanguageSearchEvent;
    case: "naturalLanguageSearch";
  } | {
    /**
     * Tour booking funnel
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStartedEvent tour_flow_started = 10;
     */
    value: MarketplacePropertyCategory_TourFlowStartedEvent;
    case: "tourFlowStarted";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent tour_slot_selected = 11;
     */
    value: MarketplacePropertyCategory_TourSlotSelectedEvent;
    case: "tourSlotSelected";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationStartedEvent tour_verification_started = 12;
     */
    value: MarketplacePropertyCategory_TourVerificationStartedEvent;
    case: "tourVerificationStarted";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationCompletedEvent tour_verification_completed = 13;
     */
    value: MarketplacePropertyCategory_TourVerificationCompletedEvent;
    case: "tourVerificationCompleted";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingAttemptedEvent tour_booking_attempted = 14;
     */
    value: MarketplacePropertyCategory_TourBookingAttemptedEvent;
    case: "tourBookingAttempted";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingCompletedEvent tour_booking_completed = 15;
     */
    value: MarketplacePropertyCategory_TourBookingCompletedEvent;
    case: "tourBookingCompleted";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent tour_flow_abandoned = 16;
     */
    value: MarketplacePropertyCategory_TourFlowAbandonedEvent;
    case: "tourFlowAbandoned";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent idv_session_denied = 17;
     */
    value: MarketplacePropertyCategory_IdvSessionDeniedEvent;
    case: "idvSessionDenied";
  } | {
    /**
     * Tour management
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelConfirmedEvent tour_cancel_confirmed = 18;
     */
    value: MarketplacePropertyCategory_TourCancelConfirmedEvent;
    case: "tourCancelConfirmed";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelSucceededEvent tour_cancel_succeeded = 19;
     */
    value: MarketplacePropertyCategory_TourCancelSucceededEvent;
    case: "tourCancelSucceeded";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent tour_feedback_submitted = 20;
     */
    value: MarketplacePropertyCategory_TourFeedbackSubmittedEvent;
    case: "tourFeedbackSubmitted";
  } | {
    /**
     * Tour entry
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent access_code_loaded = 21;
     */
    value: MarketplacePropertyCategory_AccessCodeLoadedEvent;
    case: "accessCodeLoaded";
  } | {
    /**
     * Search
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent search_result_selected = 22;
     */
    value: MarketplacePropertyCategory_SearchResultSelectedEvent;
    case: "searchResultSelected";
  } | {
    /**
     * Globe usage
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeEnteredEvent map_globe_entered = 23;
     */
    value: MarketplacePropertyCategory_MapGlobeEnteredEvent;
    case: "mapGlobeEntered";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeExitedEvent map_globe_exited = 24;
     */
    value: MarketplacePropertyCategory_MapGlobeExitedEvent;
    case: "mapGlobeExited";
  } | {
    /**
     * Carousel engagement
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CarouselEngagementEvent carousel_engagement = 25;
     */
    value: MarketplacePropertyCategory_CarouselEngagementEvent;
    case: "carouselEngagement";
  } | {
    /**
     * Buyer conversion signals
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent property_search = 26;
     */
    value: MarketplacePropertyCategory_PropertySearchEvent;
    case: "propertySearch";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AddFavoriteEvent add_favorite = 27;
     */
    value: MarketplacePropertyCategory_AddFavoriteEvent;
    case: "addFavorite";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent offer_submitted = 28;
     */
    value: MarketplacePropertyCategory_OfferSubmittedEvent;
    case: "offerSubmitted";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent account_created = 29;
     */
    value: MarketplacePropertyCategory_AccountCreatedEvent;
    case: "accountCreated";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourScheduledEvent tour_scheduled = 30;
     */
    value: MarketplacePropertyCategory_TourScheduledEvent;
    case: "tourScheduled";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent tour_completed = 31;
     */
    value: MarketplacePropertyCategory_TourCompletedEvent;
    case: "tourCompleted";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory
 */
export type MarketplacePropertyCategoryJson = {
  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent detail_page_view = 1;
   */
  detailPageView?: MarketplacePropertyCategory_DetailPageViewEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent similar_homes_click = 2;
   */
  similarHomesClick?: MarketplacePropertyCategory_SimilarHomesClickEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent tour_booking_start = 3;
   */
  tourBookingStart?: MarketplacePropertyCategory_TourBookingStartEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent reaction = 4;
   */
  reaction?: MarketplacePropertyCategory_ReactionEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent offer_start = 5;
   */
  offerStart?: MarketplacePropertyCategory_OfferStartEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent share = 6;
   */
  share?: MarketplacePropertyCategory_ShareEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent rental_scam_banner_view = 7;
   */
  rentalScamBannerView?: MarketplacePropertyCategory_RentalScamBannerViewEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent rental_scam_banner_learn_more = 8;
   */
  rentalScamBannerLearnMore?: MarketplacePropertyCategory_RentalScamBannerLearnMoreEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent natural_language_search = 9;
   */
  naturalLanguageSearch?: MarketplacePropertyCategory_NaturalLanguageSearchEventJson;

  /**
   * Tour booking funnel
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStartedEvent tour_flow_started = 10;
   */
  tourFlowStarted?: MarketplacePropertyCategory_TourFlowStartedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent tour_slot_selected = 11;
   */
  tourSlotSelected?: MarketplacePropertyCategory_TourSlotSelectedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationStartedEvent tour_verification_started = 12;
   */
  tourVerificationStarted?: MarketplacePropertyCategory_TourVerificationStartedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationCompletedEvent tour_verification_completed = 13;
   */
  tourVerificationCompleted?: MarketplacePropertyCategory_TourVerificationCompletedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingAttemptedEvent tour_booking_attempted = 14;
   */
  tourBookingAttempted?: MarketplacePropertyCategory_TourBookingAttemptedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingCompletedEvent tour_booking_completed = 15;
   */
  tourBookingCompleted?: MarketplacePropertyCategory_TourBookingCompletedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent tour_flow_abandoned = 16;
   */
  tourFlowAbandoned?: MarketplacePropertyCategory_TourFlowAbandonedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent idv_session_denied = 17;
   */
  idvSessionDenied?: MarketplacePropertyCategory_IdvSessionDeniedEventJson;

  /**
   * Tour management
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelConfirmedEvent tour_cancel_confirmed = 18;
   */
  tourCancelConfirmed?: MarketplacePropertyCategory_TourCancelConfirmedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelSucceededEvent tour_cancel_succeeded = 19;
   */
  tourCancelSucceeded?: MarketplacePropertyCategory_TourCancelSucceededEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent tour_feedback_submitted = 20;
   */
  tourFeedbackSubmitted?: MarketplacePropertyCategory_TourFeedbackSubmittedEventJson;

  /**
   * Tour entry
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent access_code_loaded = 21;
   */
  accessCodeLoaded?: MarketplacePropertyCategory_AccessCodeLoadedEventJson;

  /**
   * Search
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent search_result_selected = 22;
   */
  searchResultSelected?: MarketplacePropertyCategory_SearchResultSelectedEventJson;

  /**
   * Globe usage
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeEnteredEvent map_globe_entered = 23;
   */
  mapGlobeEntered?: MarketplacePropertyCategory_MapGlobeEnteredEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeExitedEvent map_globe_exited = 24;
   */
  mapGlobeExited?: MarketplacePropertyCategory_MapGlobeExitedEventJson;

  /**
   * Carousel engagement
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CarouselEngagementEvent carousel_engagement = 25;
   */
  carouselEngagement?: MarketplacePropertyCategory_CarouselEngagementEventJson;

  /**
   * Buyer conversion signals
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent property_search = 26;
   */
  propertySearch?: MarketplacePropertyCategory_PropertySearchEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AddFavoriteEvent add_favorite = 27;
   */
  addFavorite?: MarketplacePropertyCategory_AddFavoriteEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent offer_submitted = 28;
   */
  offerSubmitted?: MarketplacePropertyCategory_OfferSubmittedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent account_created = 29;
   */
  accountCreated?: MarketplacePropertyCategory_AccountCreatedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourScheduledEvent tour_scheduled = 30;
   */
  tourScheduled?: MarketplacePropertyCategory_TourScheduledEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent tour_completed = 31;
   */
  tourCompleted?: MarketplacePropertyCategory_TourCompletedEventJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.
 * Use `create(MarketplacePropertyCategorySchema)` to create a new message.
 */
export const MarketplacePropertyCategorySchema: GenMessage<MarketplacePropertyCategory, {jsonType: MarketplacePropertyCategoryJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent
 */
export type MarketplacePropertyCategory_DetailPageViewEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent
 */
export type MarketplacePropertyCategory_DetailPageViewEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent.
 * Use `create(MarketplacePropertyCategory_DetailPageViewEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_DetailPageViewEventSchema: GenMessage<MarketplacePropertyCategory_DetailPageViewEvent, {jsonType: MarketplacePropertyCategory_DetailPageViewEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 0);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent
 */
export type MarketplacePropertyCategory_SimilarHomesClickEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string clicked_address_uuid = 2;
   */
  clickedAddressUuid: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent
 */
export type MarketplacePropertyCategory_SimilarHomesClickEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string clicked_address_uuid = 2;
   */
  clickedAddressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent.
 * Use `create(MarketplacePropertyCategory_SimilarHomesClickEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_SimilarHomesClickEventSchema: GenMessage<MarketplacePropertyCategory_SimilarHomesClickEvent, {jsonType: MarketplacePropertyCategory_SimilarHomesClickEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 1);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent
 */
export type MarketplacePropertyCategory_TourBookingStartEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string placement = 2;
   */
  placement: string;

  /**
   * List price; absent when the emitting surface does not have it loaded.
   *
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: bigint | undefined;

  /**
   * Tour path (self-tour vs tour-with-agent); placement keeps page position.
   *
   * @generated from field: string source = 4;
   */
  source: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent
 */
export type MarketplacePropertyCategory_TourBookingStartEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string placement = 2;
   */
  placement?: string;

  /**
   * List price; absent when the emitting surface does not have it loaded.
   *
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: Int64ValueJson;

  /**
   * Tour path (self-tour vs tour-with-agent); placement keeps page position.
   *
   * @generated from field: string source = 4;
   */
  source?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent.
 * Use `create(MarketplacePropertyCategory_TourBookingStartEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourBookingStartEventSchema: GenMessage<MarketplacePropertyCategory_TourBookingStartEvent, {jsonType: MarketplacePropertyCategory_TourBookingStartEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 2);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent
 */
export type MarketplacePropertyCategory_ReactionEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction reaction = 3;
   */
  reaction: MarketplacePropertyCategory_ReactionEventReaction;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent
 */
export type MarketplacePropertyCategory_ReactionEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string source = 2;
   */
  source?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction reaction = 3;
   */
  reaction?: MarketplacePropertyCategory_ReactionEventReactionJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent.
 * Use `create(MarketplacePropertyCategory_ReactionEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_ReactionEventSchema: GenMessage<MarketplacePropertyCategory_ReactionEvent, {jsonType: MarketplacePropertyCategory_ReactionEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 3);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent
 */
export type MarketplacePropertyCategory_OfferStartEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string source = 2;
   */
  source: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent
 */
export type MarketplacePropertyCategory_OfferStartEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string source = 2;
   */
  source?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent.
 * Use `create(MarketplacePropertyCategory_OfferStartEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_OfferStartEventSchema: GenMessage<MarketplacePropertyCategory_OfferStartEvent, {jsonType: MarketplacePropertyCategory_OfferStartEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 4);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent
 */
export type MarketplacePropertyCategory_ShareEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string source = 2;
   */
  source: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent
 */
export type MarketplacePropertyCategory_ShareEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string source = 2;
   */
  source?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent.
 * Use `create(MarketplacePropertyCategory_ShareEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_ShareEventSchema: GenMessage<MarketplacePropertyCategory_ShareEvent, {jsonType: MarketplacePropertyCategory_ShareEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 5);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent
 */
export type MarketplacePropertyCategory_RentalScamBannerViewEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent
 */
export type MarketplacePropertyCategory_RentalScamBannerViewEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent.
 * Use `create(MarketplacePropertyCategory_RentalScamBannerViewEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_RentalScamBannerViewEventSchema: GenMessage<MarketplacePropertyCategory_RentalScamBannerViewEvent, {jsonType: MarketplacePropertyCategory_RentalScamBannerViewEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 6);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent
 */
export type MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent
 */
export type MarketplacePropertyCategory_RentalScamBannerLearnMoreEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent.
 * Use `create(MarketplacePropertyCategory_RentalScamBannerLearnMoreEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_RentalScamBannerLearnMoreEventSchema: GenMessage<MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent, {jsonType: MarketplacePropertyCategory_RentalScamBannerLearnMoreEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 7);

/**
 * One event per natural-language search engine call, emitted server-side by
 * Athena so iOS and web are covered without a client release. Deliberately
 * carries the raw query text: capturing what buyers ask for is this event's
 * purpose, and nothing else in the stack persists it (the engine's own
 * telemetry is bounded enums only). Map surfaces re-issue the engine call on
 * every viewport settle, so consumers should expect several rows per typed
 * query and dedupe on (identity, query, surface) over a time window.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent
 */
export type MarketplacePropertyCategory_NaturalLanguageSearchEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent.Surface surface = 2;
   */
  surface: MarketplacePropertyCategory_NaturalLanguageSearchEvent_Surface;

  /**
   * @generated from field: string graphql_client_name = 3;
   */
  graphqlClientName: string;

  /**
   * @generated from field: string market = 4;
   */
  market: string;

  /**
   * Whether the request carried a viewport bounding box (bounded searches
   * are viewport-scoped; unbounded ones are nationwide).
   *
   * @generated from field: bool bounded = 5;
   */
  bounded: boolean;

  /**
   * Wrapper rather than a bare int: the standalone query legitimately
   * omits limit (the engine applies its default), and a warehouse row must
   * distinguish that from a real zero because results_truncated is only
   * interpretable against the page size.
   *
   * @generated from field: google.protobuf.Int32Value limit = 6;
   */
  limit?: number | undefined;

  /**
   * Geohash precision of the clustered fetch; absent for pins/standalone.
   *
   * @generated from field: google.protobuf.Int32Value cluster_precision = 7;
   */
  clusterPrecision?: number | undefined;

  /**
   * @generated from field: int32 homes_returned = 8;
   */
  homesReturned: number;

  /**
   * @generated from field: string empty_reason = 9;
   */
  emptyReason: string;

  /**
   * @generated from field: bool results_truncated = 10;
   */
  resultsTruncated: boolean;

  /**
   * @generated from field: int64 engine_latency_ms = 11;
   */
  engineLatencyMs: bigint;
};

/**
 * One event per natural-language search engine call, emitted server-side by
 * Athena so iOS and web are covered without a client release. Deliberately
 * carries the raw query text: capturing what buyers ask for is this event's
 * purpose, and nothing else in the stack persists it (the engine's own
 * telemetry is bounded enums only). Map surfaces re-issue the engine call on
 * every viewport settle, so consumers should expect several rows per typed
 * query and dedupe on (identity, query, surface) over a time window.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent
 */
export type MarketplacePropertyCategory_NaturalLanguageSearchEventJson = {
  /**
   * @generated from field: string query = 1;
   */
  query?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent.Surface surface = 2;
   */
  surface?: MarketplacePropertyCategory_NaturalLanguageSearchEvent_SurfaceJson;

  /**
   * @generated from field: string graphql_client_name = 3;
   */
  graphqlClientName?: string;

  /**
   * @generated from field: string market = 4;
   */
  market?: string;

  /**
   * Whether the request carried a viewport bounding box (bounded searches
   * are viewport-scoped; unbounded ones are nationwide).
   *
   * @generated from field: bool bounded = 5;
   */
  bounded?: boolean;

  /**
   * Wrapper rather than a bare int: the standalone query legitimately
   * omits limit (the engine applies its default), and a warehouse row must
   * distinguish that from a real zero because results_truncated is only
   * interpretable against the page size.
   *
   * @generated from field: google.protobuf.Int32Value limit = 6;
   */
  limit?: Int32ValueJson;

  /**
   * Geohash precision of the clustered fetch; absent for pins/standalone.
   *
   * @generated from field: google.protobuf.Int32Value cluster_precision = 7;
   */
  clusterPrecision?: Int32ValueJson;

  /**
   * @generated from field: int32 homes_returned = 8;
   */
  homesReturned?: number;

  /**
   * @generated from field: string empty_reason = 9;
   */
  emptyReason?: string;

  /**
   * @generated from field: bool results_truncated = 10;
   */
  resultsTruncated?: boolean;

  /**
   * @generated from field: int64 engine_latency_ms = 11;
   */
  engineLatencyMs?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent.
 * Use `create(MarketplacePropertyCategory_NaturalLanguageSearchEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_NaturalLanguageSearchEventSchema: GenMessage<MarketplacePropertyCategory_NaturalLanguageSearchEvent, {jsonType: MarketplacePropertyCategory_NaturalLanguageSearchEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 8);

/**
 * Athena surface that issued the engine call. The map surfaces mirror
 * marketplace.propertySearch's fetch split: a clustered fetch renders
 * count bubbles, a pins fetch renders individual homes.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent.Surface
 */
export enum MarketplacePropertyCategory_NaturalLanguageSearchEvent_Surface {
  /**
   * @generated from enum value: SURFACE_UNSPECIFIED = 0;
   */
  SURFACE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: STANDALONE = 1;
   */
  STANDALONE = 1,

  /**
   * @generated from enum value: MAP_CLUSTERS = 2;
   */
  MAP_CLUSTERS = 2,

  /**
   * @generated from enum value: MAP_PINS = 3;
   */
  MAP_PINS = 3,
}

/**
 * Athena surface that issued the engine call. The map surfaces mirror
 * marketplace.propertySearch's fetch split: a clustered fetch renders
 * count bubbles, a pins fetch renders individual homes.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent.Surface
 */
export type MarketplacePropertyCategory_NaturalLanguageSearchEvent_SurfaceJson = "SURFACE_UNSPECIFIED" | "STANDALONE" | "MAP_CLUSTERS" | "MAP_PINS";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent.Surface.
 */
export const MarketplacePropertyCategory_NaturalLanguageSearchEvent_SurfaceSchema: GenEnum<MarketplacePropertyCategory_NaturalLanguageSearchEvent_Surface, MarketplacePropertyCategory_NaturalLanguageSearchEvent_SurfaceJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 8, 0);

/**
 * Tour booking funnel — emitted by iOS at each step from "Schedule Tour"
 * through identity verification and booking submission. Together with
 * TourBookingStartEvent above, these support drop-off analysis. Client
 * errors are deliberately not modeled here: they go to Sentry, and a
 * funnel gap (started without completed) marks the drop-off.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStartedEvent
 */
export type MarketplacePropertyCategory_TourFlowStartedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStartedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: bool can_tour_now = 2;
   */
  canTourNow: boolean;

  /**
   * @generated from field: bool is_verified = 3;
   */
  isVerified: boolean;
};

/**
 * Tour booking funnel — emitted by iOS at each step from "Schedule Tour"
 * through identity verification and booking submission. Together with
 * TourBookingStartEvent above, these support drop-off analysis. Client
 * errors are deliberately not modeled here: they go to Sentry, and a
 * funnel gap (started without completed) marks the drop-off.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStartedEvent
 */
export type MarketplacePropertyCategory_TourFlowStartedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: bool can_tour_now = 2;
   */
  canTourNow?: boolean;

  /**
   * @generated from field: bool is_verified = 3;
   */
  isVerified?: boolean;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStartedEvent.
 * Use `create(MarketplacePropertyCategory_TourFlowStartedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourFlowStartedEventSchema: GenMessage<MarketplacePropertyCategory_TourFlowStartedEvent, {jsonType: MarketplacePropertyCategory_TourFlowStartedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 9);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent
 */
export type MarketplacePropertyCategory_TourSlotSelectedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string slot_time = 2;
   */
  slotTime: string;

  /**
   * @generated from field: bool is_tour_now = 3;
   */
  isTourNow: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent.TimeGroup time_group = 4;
   */
  timeGroup: MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroup;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent
 */
export type MarketplacePropertyCategory_TourSlotSelectedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string slot_time = 2;
   */
  slotTime?: string;

  /**
   * @generated from field: bool is_tour_now = 3;
   */
  isTourNow?: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent.TimeGroup time_group = 4;
   */
  timeGroup?: MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroupJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent.
 * Use `create(MarketplacePropertyCategory_TourSlotSelectedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourSlotSelectedEventSchema: GenMessage<MarketplacePropertyCategory_TourSlotSelectedEvent, {jsonType: MarketplacePropertyCategory_TourSlotSelectedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 10);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent.TimeGroup
 */
export enum MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroup {
  /**
   * @generated from enum value: TIME_GROUP_UNSPECIFIED = 0;
   */
  TIME_GROUP_UNSPECIFIED = 0,

  /**
   * @generated from enum value: MORNING = 1;
   */
  MORNING = 1,

  /**
   * @generated from enum value: AFTERNOON = 2;
   */
  AFTERNOON = 2,

  /**
   * @generated from enum value: EVENING = 3;
   */
  EVENING = 3,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent.TimeGroup
 */
export type MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroupJson = "TIME_GROUP_UNSPECIFIED" | "MORNING" | "AFTERNOON" | "EVENING";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent.TimeGroup.
 */
export const MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroupSchema: GenEnum<MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroup, MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroupJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 10, 0);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationStartedEvent
 */
export type MarketplacePropertyCategory_TourVerificationStartedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationStartedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep step = 2;
   */
  step: MarketplacePropertyCategory_VerificationStep;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationStartedEvent
 */
export type MarketplacePropertyCategory_TourVerificationStartedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep step = 2;
   */
  step?: MarketplacePropertyCategory_VerificationStepJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationStartedEvent.
 * Use `create(MarketplacePropertyCategory_TourVerificationStartedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourVerificationStartedEventSchema: GenMessage<MarketplacePropertyCategory_TourVerificationStartedEvent, {jsonType: MarketplacePropertyCategory_TourVerificationStartedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 11);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationCompletedEvent
 */
export type MarketplacePropertyCategory_TourVerificationCompletedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationCompletedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep step = 2;
   */
  step: MarketplacePropertyCategory_VerificationStep;

  /**
   * Wrapper rather than a bare int: the emitter loses the step-start
   * timestamp across process restarts, and a warehouse row must
   * distinguish "unmeasured" from an instantaneous step.
   *
   * @generated from field: google.protobuf.Int32Value duration_ms = 3;
   */
  durationMs?: number | undefined;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationCompletedEvent
 */
export type MarketplacePropertyCategory_TourVerificationCompletedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep step = 2;
   */
  step?: MarketplacePropertyCategory_VerificationStepJson;

  /**
   * Wrapper rather than a bare int: the emitter loses the step-start
   * timestamp across process restarts, and a warehouse row must
   * distinguish "unmeasured" from an instantaneous step.
   *
   * @generated from field: google.protobuf.Int32Value duration_ms = 3;
   */
  durationMs?: Int32ValueJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationCompletedEvent.
 * Use `create(MarketplacePropertyCategory_TourVerificationCompletedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourVerificationCompletedEventSchema: GenMessage<MarketplacePropertyCategory_TourVerificationCompletedEvent, {jsonType: MarketplacePropertyCategory_TourVerificationCompletedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 12);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingAttemptedEvent
 */
export type MarketplacePropertyCategory_TourBookingAttemptedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingAttemptedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string slot_time = 2;
   */
  slotTime: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingAttemptedEvent
 */
export type MarketplacePropertyCategory_TourBookingAttemptedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string slot_time = 2;
   */
  slotTime?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingAttemptedEvent.
 * Use `create(MarketplacePropertyCategory_TourBookingAttemptedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourBookingAttemptedEventSchema: GenMessage<MarketplacePropertyCategory_TourBookingAttemptedEvent, {jsonType: MarketplacePropertyCategory_TourBookingAttemptedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 13);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingCompletedEvent
 */
export type MarketplacePropertyCategory_TourBookingCompletedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingCompletedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string booking_id = 2;
   */
  bookingId: string;

  /**
   * @generated from field: string slot_time = 3;
   */
  slotTime: string;

  /**
   * Wrapper rather than a bare int: the emitter loses the flow-start
   * timestamp across process restarts, and a warehouse row must
   * distinguish "unmeasured" from an instantaneous booking.
   *
   * @generated from field: google.protobuf.Int32Value total_flow_duration_ms = 4;
   */
  totalFlowDurationMs?: number | undefined;

  /**
   * @generated from field: int32 steps_count = 5;
   */
  stepsCount: number;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingCompletedEvent
 */
export type MarketplacePropertyCategory_TourBookingCompletedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string booking_id = 2;
   */
  bookingId?: string;

  /**
   * @generated from field: string slot_time = 3;
   */
  slotTime?: string;

  /**
   * Wrapper rather than a bare int: the emitter loses the flow-start
   * timestamp across process restarts, and a warehouse row must
   * distinguish "unmeasured" from an instantaneous booking.
   *
   * @generated from field: google.protobuf.Int32Value total_flow_duration_ms = 4;
   */
  totalFlowDurationMs?: Int32ValueJson;

  /**
   * @generated from field: int32 steps_count = 5;
   */
  stepsCount?: number;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingCompletedEvent.
 * Use `create(MarketplacePropertyCategory_TourBookingCompletedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourBookingCompletedEventSchema: GenMessage<MarketplacePropertyCategory_TourBookingCompletedEvent, {jsonType: MarketplacePropertyCategory_TourBookingCompletedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 14);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent
 */
export type MarketplacePropertyCategory_TourFlowAbandonedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.FlowStep last_step = 2;
   */
  lastStep: MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStep;

  /**
   * @generated from field: bool had_slot_selected = 3;
   */
  hadSlotSelected: boolean;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent
 */
export type MarketplacePropertyCategory_TourFlowAbandonedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.FlowStep last_step = 2;
   */
  lastStep?: MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStepJson;

  /**
   * @generated from field: bool had_slot_selected = 3;
   */
  hadSlotSelected?: boolean;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.
 * Use `create(MarketplacePropertyCategory_TourFlowAbandonedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourFlowAbandonedEventSchema: GenMessage<MarketplacePropertyCategory_TourFlowAbandonedEvent, {jsonType: MarketplacePropertyCategory_TourFlowAbandonedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 15);

/**
 * Mirrors the client's TourFlowStep navigation enum. Emitters must map
 * cases explicitly — never stringify the client value, whose confirmation
 * case carries a whole booking model.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.FlowStep
 */
export enum MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStep {
  /**
   * @generated from enum value: FLOW_STEP_UNSPECIFIED = 0;
   */
  FLOW_STEP_UNSPECIFIED = 0,

  /**
   * @generated from enum value: TIME_SELECTION = 1;
   */
  TIME_SELECTION = 1,

  /**
   * @generated from enum value: LOGIN = 2;
   */
  LOGIN = 2,

  /**
   * @generated from enum value: PHONE_VERIFICATION = 3;
   */
  PHONE_VERIFICATION = 3,

  /**
   * @generated from enum value: ID_VERIFICATION = 4;
   */
  ID_VERIFICATION = 4,

  /**
   * @generated from enum value: REVIEW = 5;
   */
  REVIEW = 5,

  /**
   * @generated from enum value: CONFIRMATION = 6;
   */
  CONFIRMATION = 6,
}

/**
 * Mirrors the client's TourFlowStep navigation enum. Emitters must map
 * cases explicitly — never stringify the client value, whose confirmation
 * case carries a whole booking model.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.FlowStep
 */
export type MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStepJson = "FLOW_STEP_UNSPECIFIED" | "TIME_SELECTION" | "LOGIN" | "PHONE_VERIFICATION" | "ID_VERIFICATION" | "REVIEW" | "CONFIRMATION";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.FlowStep.
 */
export const MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStepSchema: GenEnum<MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStep, MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStepJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 15, 0);

/**
 * A denial is a business outcome (e.g. RETRY_THRESHOLD_REACHED blocks the
 * user from booking), not a client error — the server responds successfully
 * with a denied status, so Sentry never sees it. Kept so funnel analysis
 * can distinguish "denied" from "abandoned".
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent
 */
export type MarketplacePropertyCategory_IdvSessionDeniedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent.DenialReason denial_reason = 2;
   */
  denialReason: MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReason;
};

/**
 * A denial is a business outcome (e.g. RETRY_THRESHOLD_REACHED blocks the
 * user from booking), not a client error — the server responds successfully
 * with a denied status, so Sentry never sees it. Kept so funnel analysis
 * can distinguish "denied" from "abandoned".
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent
 */
export type MarketplacePropertyCategory_IdvSessionDeniedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent.DenialReason denial_reason = 2;
   */
  denialReason?: MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReasonJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent.
 * Use `create(MarketplacePropertyCategory_IdvSessionDeniedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_IdvSessionDeniedEventSchema: GenMessage<MarketplacePropertyCategory_IdvSessionDeniedEvent, {jsonType: MarketplacePropertyCategory_IdvSessionDeniedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 16);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent.DenialReason
 */
export enum MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReason {
  /**
   * @generated from enum value: DENIAL_REASON_UNSPECIFIED = 0;
   */
  DENIAL_REASON_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ALREADY_VERIFIED = 1;
   */
  ALREADY_VERIFIED = 1,

  /**
   * @generated from enum value: RETRY_THRESHOLD_REACHED = 2;
   */
  RETRY_THRESHOLD_REACHED = 2,

  /**
   * @generated from enum value: FEATURE_DISABLED = 3;
   */
  FEATURE_DISABLED = 3,

  /**
   * @generated from enum value: TIMED_OUT = 4;
   */
  TIMED_OUT = 4,

  /**
   * The server returned a reason this client build does not recognize.
   *
   * @generated from enum value: UNKNOWN = 5;
   */
  UNKNOWN = 5,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent.DenialReason
 */
export type MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReasonJson = "DENIAL_REASON_UNSPECIFIED" | "ALREADY_VERIFIED" | "RETRY_THRESHOLD_REACHED" | "FEATURE_DISABLED" | "TIMED_OUT" | "UNKNOWN";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent.DenialReason.
 */
export const MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReasonSchema: GenEnum<MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReason, MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReasonJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 16, 0);

/**
 * Tour management — cancellation funnel and post-tour feedback.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelConfirmedEvent
 */
export type MarketplacePropertyCategory_TourCancelConfirmedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelConfirmedEvent"> & {
  /**
   * @generated from field: string tour_id = 1;
   */
  tourId: string;

  /**
   * @generated from field: string address_uuid = 2;
   */
  addressUuid: string;
};

/**
 * Tour management — cancellation funnel and post-tour feedback.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelConfirmedEvent
 */
export type MarketplacePropertyCategory_TourCancelConfirmedEventJson = {
  /**
   * @generated from field: string tour_id = 1;
   */
  tourId?: string;

  /**
   * @generated from field: string address_uuid = 2;
   */
  addressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelConfirmedEvent.
 * Use `create(MarketplacePropertyCategory_TourCancelConfirmedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourCancelConfirmedEventSchema: GenMessage<MarketplacePropertyCategory_TourCancelConfirmedEvent, {jsonType: MarketplacePropertyCategory_TourCancelConfirmedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 17);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelSucceededEvent
 */
export type MarketplacePropertyCategory_TourCancelSucceededEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelSucceededEvent"> & {
  /**
   * @generated from field: string tour_id = 1;
   */
  tourId: string;

  /**
   * @generated from field: string address_uuid = 2;
   */
  addressUuid: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelSucceededEvent
 */
export type MarketplacePropertyCategory_TourCancelSucceededEventJson = {
  /**
   * @generated from field: string tour_id = 1;
   */
  tourId?: string;

  /**
   * @generated from field: string address_uuid = 2;
   */
  addressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelSucceededEvent.
 * Use `create(MarketplacePropertyCategory_TourCancelSucceededEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourCancelSucceededEventSchema: GenMessage<MarketplacePropertyCategory_TourCancelSucceededEvent, {jsonType: MarketplacePropertyCategory_TourCancelSucceededEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 18);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent
 */
export type MarketplacePropertyCategory_TourFeedbackSubmittedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.Sentiment sentiment = 2;
   */
  sentiment: MarketplacePropertyCategory_TourFeedbackSubmittedEvent_Sentiment;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.FeedbackSource source = 3;
   */
  source: MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSource;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent
 */
export type MarketplacePropertyCategory_TourFeedbackSubmittedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.Sentiment sentiment = 2;
   */
  sentiment?: MarketplacePropertyCategory_TourFeedbackSubmittedEvent_SentimentJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.FeedbackSource source = 3;
   */
  source?: MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSourceJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.
 * Use `create(MarketplacePropertyCategory_TourFeedbackSubmittedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourFeedbackSubmittedEventSchema: GenMessage<MarketplacePropertyCategory_TourFeedbackSubmittedEvent, {jsonType: MarketplacePropertyCategory_TourFeedbackSubmittedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 19);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.Sentiment
 */
export enum MarketplacePropertyCategory_TourFeedbackSubmittedEvent_Sentiment {
  /**
   * @generated from enum value: SENTIMENT_UNSPECIFIED = 0;
   */
  SENTIMENT_UNSPECIFIED = 0,

  /**
   * @generated from enum value: POSITIVE = 1;
   */
  POSITIVE = 1,

  /**
   * @generated from enum value: NEUTRAL = 2;
   */
  NEUTRAL = 2,

  /**
   * @generated from enum value: NEGATIVE = 3;
   */
  NEGATIVE = 3,

  /**
   * @generated from enum value: UNKNOWN = 4;
   */
  UNKNOWN = 4,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.Sentiment
 */
export type MarketplacePropertyCategory_TourFeedbackSubmittedEvent_SentimentJson = "SENTIMENT_UNSPECIFIED" | "POSITIVE" | "NEUTRAL" | "NEGATIVE" | "UNKNOWN";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.Sentiment.
 */
export const MarketplacePropertyCategory_TourFeedbackSubmittedEvent_SentimentSchema: GenEnum<MarketplacePropertyCategory_TourFeedbackSubmittedEvent_Sentiment, MarketplacePropertyCategory_TourFeedbackSubmittedEvent_SentimentJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 19, 0);

/**
 * Which feedback surface submitted: the one-tap prompt on the Home tab
 * or the full form with aspects and free text.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.FeedbackSource
 */
export enum MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSource {
  /**
   * @generated from enum value: FEEDBACK_SOURCE_UNSPECIFIED = 0;
   */
  FEEDBACK_SOURCE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: QUICK = 1;
   */
  QUICK = 1,

  /**
   * @generated from enum value: DETAILED = 2;
   */
  DETAILED = 2,
}

/**
 * Which feedback surface submitted: the one-tap prompt on the Home tab
 * or the full form with aspects and free text.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.FeedbackSource
 */
export type MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSourceJson = "FEEDBACK_SOURCE_UNSPECIFIED" | "QUICK" | "DETAILED";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.FeedbackSource.
 */
export const MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSourceSchema: GenEnum<MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSource, MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSourceJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 19, 1);

/**
 * Tour entry — the door access code loaded, marking the user's path
 * into the home after booking. Load errors and poll timeouts are Sentry
 * territory, not modeled here.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent
 */
export type MarketplacePropertyCategory_AccessCodeLoadedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent.SecuritySystemType security_system_type = 3;
   */
  securitySystemType: MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemType;
};

/**
 * Tour entry — the door access code loaded, marking the user's path
 * into the home after booking. Load errors and poll timeouts are Sentry
 * territory, not modeled here.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent
 */
export type MarketplacePropertyCategory_AccessCodeLoadedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent.SecuritySystemType security_system_type = 3;
   */
  securitySystemType?: MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemTypeJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent.
 * Use `create(MarketplacePropertyCategory_AccessCodeLoadedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_AccessCodeLoadedEventSchema: GenMessage<MarketplacePropertyCategory_AccessCodeLoadedEvent, {jsonType: MarketplacePropertyCategory_AccessCodeLoadedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 20);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent.SecuritySystemType
 */
export enum MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemType {
  /**
   * @generated from enum value: SECURITY_SYSTEM_TYPE_UNSPECIFIED = 0;
   */
  SECURITY_SYSTEM_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: SMARTRENT = 1;
   */
  SMARTRENT = 1,

  /**
   * @generated from enum value: ARCO = 2;
   */
  ARCO = 2,

  /**
   * @generated from enum value: CLEMENTINE = 3;
   */
  CLEMENTINE = 3,

  /**
   * @generated from enum value: KNOX = 4;
   */
  KNOX = 4,

  /**
   * @generated from enum value: LINK = 5;
   */
  LINK = 5,

  /**
   * @generated from enum value: NONE = 6;
   */
  NONE = 6,

  /**
   * The server returned a vendor this client build does not recognize.
   *
   * @generated from enum value: UNKNOWN = 7;
   */
  UNKNOWN = 7,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent.SecuritySystemType
 */
export type MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemTypeJson = "SECURITY_SYSTEM_TYPE_UNSPECIFIED" | "SMARTRENT" | "ARCO" | "CLEMENTINE" | "KNOX" | "LINK" | "NONE" | "UNKNOWN";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent.SecuritySystemType.
 */
export const MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemTypeSchema: GenEnum<MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemType, MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemTypeJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 20, 0);

/**
 * Search funnel — fires when a search result is tapped (vs abandoned).
 * No property enrichment because the search may be address-, zone-, or
 * free-text-typed. Deliberately carries no raw query text (buyers often
 * type street addresses, including their own, and Journey forwards event
 * properties to third-party CDP destinations unredacted); query_length
 * plus the selected result's type/position cover the funnel questions.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent
 */
export type MarketplacePropertyCategory_SearchResultSelectedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent"> & {
  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent.ResultType result_type = 1;
   */
  resultType: MarketplacePropertyCategory_SearchResultSelectedEvent_ResultType;

  /**
   * @generated from field: int32 query_length = 2;
   */
  queryLength: number;

  /**
   * @generated from field: int32 result_position = 3;
   */
  resultPosition: number;
};

/**
 * Search funnel — fires when a search result is tapped (vs abandoned).
 * No property enrichment because the search may be address-, zone-, or
 * free-text-typed. Deliberately carries no raw query text (buyers often
 * type street addresses, including their own, and Journey forwards event
 * properties to third-party CDP destinations unredacted); query_length
 * plus the selected result's type/position cover the funnel questions.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent
 */
export type MarketplacePropertyCategory_SearchResultSelectedEventJson = {
  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent.ResultType result_type = 1;
   */
  resultType?: MarketplacePropertyCategory_SearchResultSelectedEvent_ResultTypeJson;

  /**
   * @generated from field: int32 query_length = 2;
   */
  queryLength?: number;

  /**
   * @generated from field: int32 result_position = 3;
   */
  resultPosition?: number;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent.
 * Use `create(MarketplacePropertyCategory_SearchResultSelectedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_SearchResultSelectedEventSchema: GenMessage<MarketplacePropertyCategory_SearchResultSelectedEvent, {jsonType: MarketplacePropertyCategory_SearchResultSelectedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 21);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent.ResultType
 */
export enum MarketplacePropertyCategory_SearchResultSelectedEvent_ResultType {
  /**
   * @generated from enum value: RESULT_TYPE_UNSPECIFIED = 0;
   */
  RESULT_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ZONE = 1;
   */
  ZONE = 1,

  /**
   * @generated from enum value: LISTING = 2;
   */
  LISTING = 2,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent.ResultType
 */
export type MarketplacePropertyCategory_SearchResultSelectedEvent_ResultTypeJson = "RESULT_TYPE_UNSPECIFIED" | "ZONE" | "LISTING";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent.ResultType.
 */
export const MarketplacePropertyCategory_SearchResultSelectedEvent_ResultTypeSchema: GenEnum<MarketplacePropertyCategory_SearchResultSelectedEvent_ResultType, MarketplacePropertyCategory_SearchResultSelectedEvent_ResultTypeJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 21, 0);

/**
 * Buy-tab globe usage — the map crossfades to a 3D globe past a zoom-out
 * threshold. Entered/exited pairs answer whether the globe is a navigation
 * tool (exit somewhere new) or a toy (zoom out and straight back). No
 * property enrichment: the globe frames continents, not a listing.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeEnteredEvent
 */
export type MarketplacePropertyCategory_MapGlobeEnteredEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeEnteredEvent"> & {
};

/**
 * Buy-tab globe usage — the map crossfades to a 3D globe past a zoom-out
 * threshold. Entered/exited pairs answer whether the globe is a navigation
 * tool (exit somewhere new) or a toy (zoom out and straight back). No
 * property enrichment: the globe frames continents, not a listing.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeEnteredEvent
 */
export type MarketplacePropertyCategory_MapGlobeEnteredEventJson = {
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeEnteredEvent.
 * Use `create(MarketplacePropertyCategory_MapGlobeEnteredEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_MapGlobeEnteredEventSchema: GenMessage<MarketplacePropertyCategory_MapGlobeEnteredEvent, {jsonType: MarketplacePropertyCategory_MapGlobeEnteredEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 22);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeExitedEvent
 */
export type MarketplacePropertyCategory_MapGlobeExitedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeExitedEvent"> & {
  /**
   * @generated from field: int32 duration_ms = 1;
   */
  durationMs: number;

  /**
   * Exited viewing a meaningfully different area than entered (exceeds the
   * client's travel-distance threshold).
   *
   * @generated from field: bool region_changed = 2;
   */
  regionChanged: boolean;

  /**
   * Great-circle distance between the enter and exit map centers, rounded
   * to whole km. An integer by design: floats admit NaN (great-circle math
   * leaves the acos domain when the centers coincide) and nothing on the
   * ingest path validates floats. Emitters must clamp the acos/asin
   * argument to [-1, 1] before converting.
   *
   * @generated from field: int32 travel_distance_km = 3;
   */
  travelDistanceKm: number;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeExitedEvent
 */
export type MarketplacePropertyCategory_MapGlobeExitedEventJson = {
  /**
   * @generated from field: int32 duration_ms = 1;
   */
  durationMs?: number;

  /**
   * Exited viewing a meaningfully different area than entered (exceeds the
   * client's travel-distance threshold).
   *
   * @generated from field: bool region_changed = 2;
   */
  regionChanged?: boolean;

  /**
   * Great-circle distance between the enter and exit map centers, rounded
   * to whole km. An integer by design: floats admit NaN (great-circle math
   * leaves the acos domain when the centers coincide) and nothing on the
   * ingest path validates floats. Emitters must clamp the acos/asin
   * argument to [-1, 1] before converting.
   *
   * @generated from field: int32 travel_distance_km = 3;
   */
  travelDistanceKm?: number;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeExitedEvent.
 * Use `create(MarketplacePropertyCategory_MapGlobeExitedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_MapGlobeExitedEventSchema: GenMessage<MarketplacePropertyCategory_MapGlobeExitedEvent, {jsonType: MarketplacePropertyCategory_MapGlobeExitedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 23);

/**
 * PDP photo-carousel engagement, aggregated client-side and emitted once
 * per detail-page view when the PDP closes. Compares the two navigation
 * methods (paging swipes vs long-press scrubbing); a per-gesture event
 * stream would multiply Journey volume by the number of photos paged, so
 * the client aggregates instead.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.CarouselEngagementEvent
 */
export type MarketplacePropertyCategory_CarouselEngagementEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.CarouselEngagementEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * Photos available in the carousel when the PDP closed.
   *
   * @generated from field: int32 photo_count = 2;
   */
  photoCount: number;

  /**
   * Distinct carousel positions displayed. A scrub sweep counts only its
   * landing photo — intermediate frames are not intentional viewings —
   * and paging inside the fullscreen lightbox counts only the photo it
   * returns the carousel to (the lightbox is a separate surface).
   *
   * @generated from field: int32 photos_viewed = 3;
   */
  photosViewed: number;

  /**
   * Page changes from carousel paging swipes.
   *
   * @generated from field: int32 swipe_count = 4;
   */
  swipeCount: number;

  /**
   * Long-press scrub activations.
   *
   * @generated from field: int32 scrub_session_count = 5;
   */
  scrubSessionCount: number;

  /**
   * Page changes made while scrubbing, across all scrub sessions.
   *
   * @generated from field: int32 scrub_photo_count = 6;
   */
  scrubPhotoCount: number;

  /**
   * Deepest carousel position displayed, including mid-scrub frames and
   * the pre-positioned landing photo. Absolute gallery position, not
   * navigation depth: compute depth as max_photo_index -
   * landing_photo_index so image-search PDPs (which land mid-array) are
   * comparable to standard PDPs (which land at 0).
   *
   * @generated from field: int32 max_photo_index = 7;
   */
  maxPhotoIndex: number;

  /**
   * Carousel position the PDP opened on: 0 for standard pins, the matched
   * photo's position for image-search pins.
   *
   * @generated from field: int32 landing_photo_index = 8;
   */
  landingPhotoIndex: number;
};

/**
 * PDP photo-carousel engagement, aggregated client-side and emitted once
 * per detail-page view when the PDP closes. Compares the two navigation
 * methods (paging swipes vs long-press scrubbing); a per-gesture event
 * stream would multiply Journey volume by the number of photos paged, so
 * the client aggregates instead.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.CarouselEngagementEvent
 */
export type MarketplacePropertyCategory_CarouselEngagementEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * Photos available in the carousel when the PDP closed.
   *
   * @generated from field: int32 photo_count = 2;
   */
  photoCount?: number;

  /**
   * Distinct carousel positions displayed. A scrub sweep counts only its
   * landing photo — intermediate frames are not intentional viewings —
   * and paging inside the fullscreen lightbox counts only the photo it
   * returns the carousel to (the lightbox is a separate surface).
   *
   * @generated from field: int32 photos_viewed = 3;
   */
  photosViewed?: number;

  /**
   * Page changes from carousel paging swipes.
   *
   * @generated from field: int32 swipe_count = 4;
   */
  swipeCount?: number;

  /**
   * Long-press scrub activations.
   *
   * @generated from field: int32 scrub_session_count = 5;
   */
  scrubSessionCount?: number;

  /**
   * Page changes made while scrubbing, across all scrub sessions.
   *
   * @generated from field: int32 scrub_photo_count = 6;
   */
  scrubPhotoCount?: number;

  /**
   * Deepest carousel position displayed, including mid-scrub frames and
   * the pre-positioned landing photo. Absolute gallery position, not
   * navigation depth: compute depth as max_photo_index -
   * landing_photo_index so image-search PDPs (which land mid-array) are
   * comparable to standard PDPs (which land at 0).
   *
   * @generated from field: int32 max_photo_index = 7;
   */
  maxPhotoIndex?: number;

  /**
   * Carousel position the PDP opened on: 0 for standard pins, the matched
   * photo's position for image-search pins.
   *
   * @generated from field: int32 landing_photo_index = 8;
   */
  landingPhotoIndex?: number;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.CarouselEngagementEvent.
 * Use `create(MarketplacePropertyCategory_CarouselEngagementEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_CarouselEngagementEventSchema: GenMessage<MarketplacePropertyCategory_CarouselEngagementEvent, {jsonType: MarketplacePropertyCategory_CarouselEngagementEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 24);

/**
 * Fired client-side from /homes filter/search/map interactions. No property
 * enrichment: a search spans many homes. Deliberately carries no raw query
 * text — the same CDP-forwarding concern documented on
 * SearchResultSelectedEvent applies.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent
 */
export type MarketplacePropertyCategory_PropertySearchEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent"> & {
  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent.Trigger trigger = 1;
   */
  trigger: MarketplacePropertyCategory_PropertySearchEvent_Trigger;

  /**
   * @generated from field: string market = 2;
   */
  market: string;

  /**
   * @generated from field: int32 results_count = 3;
   */
  resultsCount: number;

  /**
   * Wrappers rather than bare ints: an unset filter must be
   * distinguishable from a real zero (e.g. min_beds of 0).
   *
   * @generated from field: google.protobuf.Int32Value min_beds = 4;
   */
  minBeds?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int32Value min_baths = 5;
   */
  minBaths?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int64Value min_price_cents = 6;
   */
  minPriceCents?: bigint | undefined;

  /**
   * @generated from field: google.protobuf.Int64Value max_price_cents = 7;
   */
  maxPriceCents?: bigint | undefined;

  /**
   * Sort slug the user selected (e.g. "price-desc"), omitted while the
   * default ordering is in effect. Producers other than the web client may
   * send the default explicitly, so treat sort IN (NULL, "newest") as
   * default.
   *
   * @generated from field: string sort = 8;
   */
  sort: string;
};

/**
 * Fired client-side from /homes filter/search/map interactions. No property
 * enrichment: a search spans many homes. Deliberately carries no raw query
 * text — the same CDP-forwarding concern documented on
 * SearchResultSelectedEvent applies.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent
 */
export type MarketplacePropertyCategory_PropertySearchEventJson = {
  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent.Trigger trigger = 1;
   */
  trigger?: MarketplacePropertyCategory_PropertySearchEvent_TriggerJson;

  /**
   * @generated from field: string market = 2;
   */
  market?: string;

  /**
   * @generated from field: int32 results_count = 3;
   */
  resultsCount?: number;

  /**
   * Wrappers rather than bare ints: an unset filter must be
   * distinguishable from a real zero (e.g. min_beds of 0).
   *
   * @generated from field: google.protobuf.Int32Value min_beds = 4;
   */
  minBeds?: Int32ValueJson;

  /**
   * @generated from field: google.protobuf.Int32Value min_baths = 5;
   */
  minBaths?: Int32ValueJson;

  /**
   * @generated from field: google.protobuf.Int64Value min_price_cents = 6;
   */
  minPriceCents?: Int64ValueJson;

  /**
   * @generated from field: google.protobuf.Int64Value max_price_cents = 7;
   */
  maxPriceCents?: Int64ValueJson;

  /**
   * Sort slug the user selected (e.g. "price-desc"), omitted while the
   * default ordering is in effect. Producers other than the web client may
   * send the default explicitly, so treat sort IN (NULL, "newest") as
   * default.
   *
   * @generated from field: string sort = 8;
   */
  sort?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent.
 * Use `create(MarketplacePropertyCategory_PropertySearchEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_PropertySearchEventSchema: GenMessage<MarketplacePropertyCategory_PropertySearchEvent, {jsonType: MarketplacePropertyCategory_PropertySearchEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 25);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent.Trigger
 */
export enum MarketplacePropertyCategory_PropertySearchEvent_Trigger {
  /**
   * @generated from enum value: TRIGGER_UNSPECIFIED = 0;
   */
  TRIGGER_UNSPECIFIED = 0,

  /**
   * @generated from enum value: FILTER_APPLY = 1;
   */
  FILTER_APPLY = 1,

  /**
   * @generated from enum value: QUICK_FILTER = 2;
   */
  QUICK_FILTER = 2,

  /**
   * @generated from enum value: MAP_MOVE = 3;
   */
  MAP_MOVE = 3,

  /**
   * @generated from enum value: LOCATION_SELECT = 4;
   */
  LOCATION_SELECT = 4,

  /**
   * @generated from enum value: SAVED_SEARCH = 5;
   */
  SAVED_SEARCH = 5,

  /**
   * @generated from enum value: RESET = 6;
   */
  RESET = 6,

  /**
   * @generated from enum value: SORT_CHANGE = 7;
   */
  SORT_CHANGE = 7,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent.Trigger
 */
export type MarketplacePropertyCategory_PropertySearchEvent_TriggerJson = "TRIGGER_UNSPECIFIED" | "FILTER_APPLY" | "QUICK_FILTER" | "MAP_MOVE" | "LOCATION_SELECT" | "SAVED_SEARCH" | "RESET" | "SORT_CHANGE";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent.Trigger.
 */
export const MarketplacePropertyCategory_PropertySearchEvent_TriggerSchema: GenEnum<MarketplacePropertyCategory_PropertySearchEvent_Trigger, MarketplacePropertyCategory_PropertySearchEvent_TriggerJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 25, 0);

/**
 * Fired alongside ReactionEvent on ADD_LIKE only: ad platforms need an
 * add-only signal, which ReactionEvent (carrying all four reactions under
 * one event name) cannot provide.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.AddFavoriteEvent
 */
export type MarketplacePropertyCategory_AddFavoriteEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.AddFavoriteEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * List price; absent when the emitting surface does not have it loaded.
   *
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: bigint | undefined;
};

/**
 * Fired alongside ReactionEvent on ADD_LIKE only: ad platforms need an
 * add-only signal, which ReactionEvent (carrying all four reactions under
 * one event name) cannot provide.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.AddFavoriteEvent
 */
export type MarketplacePropertyCategory_AddFavoriteEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string source = 2;
   */
  source?: string;

  /**
   * List price; absent when the emitting surface does not have it loaded.
   *
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: Int64ValueJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.AddFavoriteEvent.
 * Use `create(MarketplacePropertyCategory_AddFavoriteEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_AddFavoriteEventSchema: GenMessage<MarketplacePropertyCategory_AddFavoriteEvent, {jsonType: MarketplacePropertyCategory_AddFavoriteEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 26);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent
 */
export type MarketplacePropertyCategory_OfferSubmittedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string listing_offer_uuid = 2;
   */
  listingOfferUuid: string;

  /**
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: bigint | undefined;

  /**
   * @generated from field: string financing_type = 4;
   */
  financingType: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent
 */
export type MarketplacePropertyCategory_OfferSubmittedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string listing_offer_uuid = 2;
   */
  listingOfferUuid?: string;

  /**
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: Int64ValueJson;

  /**
   * @generated from field: string financing_type = 4;
   */
  financingType?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent.
 * Use `create(MarketplacePropertyCategory_OfferSubmittedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_OfferSubmittedEventSchema: GenMessage<MarketplacePropertyCategory_OfferSubmittedEvent, {jsonType: MarketplacePropertyCategory_OfferSubmittedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 27);

/**
 * Fired on buy-side registration success (cosmos /login soft gate).
 * address_uuid is empty for organic sign-ups with no listing context;
 * Journey skips property enrichment when the identifier is empty.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent
 */
export type MarketplacePropertyCategory_AccountCreatedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent.AuthMethod auth_method = 2;
   */
  authMethod: MarketplacePropertyCategory_AccountCreatedEvent_AuthMethod;
};

/**
 * Fired on buy-side registration success (cosmos /login soft gate).
 * address_uuid is empty for organic sign-ups with no listing context;
 * Journey skips property enrichment when the identifier is empty.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent
 */
export type MarketplacePropertyCategory_AccountCreatedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent.AuthMethod auth_method = 2;
   */
  authMethod?: MarketplacePropertyCategory_AccountCreatedEvent_AuthMethodJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent.
 * Use `create(MarketplacePropertyCategory_AccountCreatedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_AccountCreatedEventSchema: GenMessage<MarketplacePropertyCategory_AccountCreatedEvent, {jsonType: MarketplacePropertyCategory_AccountCreatedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 28);

/**
 * Mirrors AuthenticationCategory.AuthMethod values so emitters can map
 * one-to-one.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent.AuthMethod
 */
export enum MarketplacePropertyCategory_AccountCreatedEvent_AuthMethod {
  /**
   * @generated from enum value: AUTH_METHOD_UNSPECIFIED = 0;
   */
  AUTH_METHOD_UNSPECIFIED = 0,

  /**
   * @generated from enum value: EMAIL_PASSWORD = 1;
   */
  EMAIL_PASSWORD = 1,

  /**
   * @generated from enum value: LITE = 2;
   */
  LITE = 2,

  /**
   * @generated from enum value: GOOGLE = 3;
   */
  GOOGLE = 3,

  /**
   * @generated from enum value: FACEBOOK = 4;
   */
  FACEBOOK = 4,

  /**
   * @generated from enum value: SESSION_ALREADY_EXISTS = 5;
   */
  SESSION_ALREADY_EXISTS = 5,

  /**
   * @generated from enum value: APPLE = 6;
   */
  APPLE = 6,
}

/**
 * Mirrors AuthenticationCategory.AuthMethod values so emitters can map
 * one-to-one.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent.AuthMethod
 */
export type MarketplacePropertyCategory_AccountCreatedEvent_AuthMethodJson = "AUTH_METHOD_UNSPECIFIED" | "EMAIL_PASSWORD" | "LITE" | "GOOGLE" | "FACEBOOK" | "SESSION_ALREADY_EXISTS" | "APPLE";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent.AuthMethod.
 */
export const MarketplacePropertyCategory_AccountCreatedEvent_AuthMethodSchema: GenEnum<MarketplacePropertyCategory_AccountCreatedEvent_AuthMethod, MarketplacePropertyCategory_AccountCreatedEvent_AuthMethodJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 28, 0);

/**
 * A Rails viewing appointment was booked or rescheduled. Distinct from
 * tour_booking_start (CTA intent) and tour_booking_completed (iOS
 * booking-flow stub).
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourScheduledEvent
 */
export type MarketplacePropertyCategory_TourScheduledEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourScheduledEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: Timestamp | undefined;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent: boolean;
};

/**
 * A Rails viewing appointment was booked or rescheduled. Distinct from
 * tour_booking_start (CTA intent) and tour_booking_completed (iOS
 * booking-flow stub).
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourScheduledEvent
 */
export type MarketplacePropertyCategory_TourScheduledEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId?: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: TimestampJson;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent?: boolean;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourScheduledEvent.
 * Use `create(MarketplacePropertyCategory_TourScheduledEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourScheduledEventSchema: GenMessage<MarketplacePropertyCategory_TourScheduledEvent, {jsonType: MarketplacePropertyCategory_TourScheduledEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 29);

/**
 * The appointment's scheduled start elapsed without cancel or reschedule.
 * ASSUMED_ELAPSED means no attendance check ran.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent
 */
export type MarketplacePropertyCategory_TourCompletedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: Timestamp | undefined;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent.CompletionSignal completion_signal = 6;
   */
  completionSignal: MarketplacePropertyCategory_TourCompletedEvent_CompletionSignal;
};

/**
 * The appointment's scheduled start elapsed without cancel or reschedule.
 * ASSUMED_ELAPSED means no attendance check ran.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent
 */
export type MarketplacePropertyCategory_TourCompletedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId?: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: TimestampJson;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent?: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent.CompletionSignal completion_signal = 6;
   */
  completionSignal?: MarketplacePropertyCategory_TourCompletedEvent_CompletionSignalJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent.
 * Use `create(MarketplacePropertyCategory_TourCompletedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourCompletedEventSchema: GenMessage<MarketplacePropertyCategory_TourCompletedEvent, {jsonType: MarketplacePropertyCategory_TourCompletedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 30);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent.CompletionSignal
 */
export enum MarketplacePropertyCategory_TourCompletedEvent_CompletionSignal {
  /**
   * @generated from enum value: COMPLETION_SIGNAL_UNSPECIFIED = 0;
   */
  COMPLETION_SIGNAL_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ASSUMED_ELAPSED = 1;
   */
  ASSUMED_ELAPSED = 1,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent.CompletionSignal
 */
export type MarketplacePropertyCategory_TourCompletedEvent_CompletionSignalJson = "COMPLETION_SIGNAL_UNSPECIFIED" | "ASSUMED_ELAPSED";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent.CompletionSignal.
 */
export const MarketplacePropertyCategory_TourCompletedEvent_CompletionSignalSchema: GenEnum<MarketplacePropertyCategory_TourCompletedEvent_CompletionSignal, MarketplacePropertyCategory_TourCompletedEvent_CompletionSignalJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 30, 0);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction
 */
export enum MarketplacePropertyCategory_ReactionEventReaction {
  /**
   * @generated from enum value: REACTION_UNSPECIFIED = 0;
   */
  REACTION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: REACTION_ADD_LIKE = 1;
   */
  REACTION_ADD_LIKE = 1,

  /**
   * @generated from enum value: REACTION_REMOVE_LIKE = 2;
   */
  REACTION_REMOVE_LIKE = 2,

  /**
   * @generated from enum value: REACTION_ADD_DISLIKE = 3;
   */
  REACTION_ADD_DISLIKE = 3,

  /**
   * @generated from enum value: REACTION_REMOVE_DISLIKE = 4;
   */
  REACTION_REMOVE_DISLIKE = 4,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction
 */
export type MarketplacePropertyCategory_ReactionEventReactionJson = "REACTION_UNSPECIFIED" | "REACTION_ADD_LIKE" | "REACTION_REMOVE_LIKE" | "REACTION_ADD_DISLIKE" | "REACTION_REMOVE_DISLIKE";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction.
 */
export const MarketplacePropertyCategory_ReactionEventReactionSchema: GenEnum<MarketplacePropertyCategory_ReactionEventReaction, MarketplacePropertyCategory_ReactionEventReactionJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 0);

/**
 * Shared by TourVerificationStartedEvent and TourVerificationCompletedEvent.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep
 */
export enum MarketplacePropertyCategory_VerificationStep {
  /**
   * @generated from enum value: VERIFICATION_STEP_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VERIFICATION_STEP_LOGIN = 1;
   */
  LOGIN = 1,

  /**
   * @generated from enum value: VERIFICATION_STEP_PHONE = 2;
   */
  PHONE = 2,

  /**
   * @generated from enum value: VERIFICATION_STEP_IDENTITY = 3;
   */
  IDENTITY = 3,
}

/**
 * Shared by TourVerificationStartedEvent and TourVerificationCompletedEvent.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep
 */
export type MarketplacePropertyCategory_VerificationStepJson = "VERIFICATION_STEP_UNSPECIFIED" | "VERIFICATION_STEP_LOGIN" | "VERIFICATION_STEP_PHONE" | "VERIFICATION_STEP_IDENTITY";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep.
 */
export const MarketplacePropertyCategory_VerificationStepSchema: GenEnum<MarketplacePropertyCategory_VerificationStep, MarketplacePropertyCategory_VerificationStepJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 1);

